const bookingWidget = () => {

    //Main Peak booking widget
    resyWidget.addButton(document.getElementById('header__reservation-button'), {"venueId":10087,"apiKey":"pVKl2jyQ07Rt2jEi649JNtCIc2pT5oR4","replace":true,});
    resyWidget.addButton(document.getElementById('popup__reservation-button'), {"venueId":10087,"apiKey":"pVKl2jyQ07Rt2jEi649JNtCIc2pT5oR4","replace":true,});

    //Quinn Bar BOoking Widget
    resyWidget.addButton(document.getElementById('header__reservation-button-quinn'), {"venueId":83649,"apiKey":"rGaRqLqR9ksFqY4x907UF9HITsClGwQO","replace":true,});

    //Peakaboo booking widget
    resyWidget.addButton(document.getElementById('header__reservation-button-peakboo'), {"venueId":60380,"apiKey":"4xCCgWySkJs0S20n2KjuSpEpdyYM0lwD","replace":true,});


    //Custom booking event for GA
    const gaBookingButtons = document.querySelectorAll('.js__ga-booking');
    for (var i = 0, button; button = gaBookingButtons[i]; i++) {
        button.addEventListener('click', event => {
         if ("ga" in window) {
            event.preventDefault(); 
            let tracker = ga.getAll()[0];
            if (tracker) {
              ga('send', {
                hitType: 'event',
                eventCategory: 'Bookings',
                eventAction: 'Click',
                eventLabel: 'Booking intentions'
              });
              tracker.send("event", "Bookings", "Booking intentions");
            }
          }
        });
    }
};